import React from 'react';
import styles from './IconButton.module.scss';
import { ShareIcon } from '../../icons/share';
import { gtag } from '../../utils/analytics';
import { Button } from './Button';

export function NativeShareButton({ data, text }: NativeShareButtonProps) {
  function share() {
    navigator
      .share(data)
      .then(() => {
        gtag('event', 'native share', {
          event_category: 'sharing',
          event_label: data.url,
        });
      })
      .catch(() => {
        // share throws if the user doesn't share
        gtag('event', 'cancel native share', {
          event_category: 'sharing',
          event_label: data.url,
        });
      });
  }

  if (text) {
    return (
      <Button xsmall fullWidth onClick={share}>
        <ShareIcon /> {text}
      </Button>
    );
  }

  return (
    <button className={styles.iconButton} onClick={share}>
      <ShareIcon />
    </button>
  );
}

export type NativeShareButtonProps = {
  data: ShareData;
  text?: string;
};
